<div
  *ngIf="
    notification.sender &&
    notification.subscriber &&
    notification.activity.object &&
    notification.activity.actor &&
    notification.activity.target
  "
  class="card-comment"
  style="line-height: 100%"
>
  <div class="card-block-small">
    <img
      *ngIf="notification.sender.image"
      class="notification-user-img"
      [src]="notification.sender.image"
      alt="sender-image"
    />
    <img
      *ngIf="!notification.sender.image"
      class="notification-user-img"
      [src]="defaultUserImg"
      alt="sender-image"
    />
    <div class="comment-desc">
      <div class="text-left">
        <h6 class="text-secondary">
          <strong>
            <span>{{ notification.sender.username | slice: 0:25 }} </span>
            <span>{{ notification.activity.verb }} </span>
            <span>a </span>
            <span>{{ notification.activity.objectModel }} </span>
            <span>to </span>
          </strong>
        </h6>

        <div *ngIf="notification.activity.targetModel === 'Discussion'">
          <a [routerLink]="['/discussion', notification.activity.target.slug]">
            <strong>
              <p
                style="margin: 0"
                class="text-muted"
                [innerHTML]="notification.activity.target.title | slice: 0:75"
              ></p>
            </strong>
          </a>
        </div>

        <div>
          <p
            class="text-muted"
            [innerHTML]="notification.activity.object.body | slice: 0:75"
          ></p>
        </div>
      </div>

      <div class="text-left">
        <span class="text-muted">
          <em>
            ...
            {{ notification.activity.verb }} on,
            {{ notification.createdAt | date: "longDate":"UTC" }}
          </em>
        </span>
      </div>
      <div class="text-left m-t-5" (click)="markAsRead()">
        <i class="text-primary icofont icofont-tick-boxed"> </i>&nbsp;
        <span class="text-muted"><em>mark as read</em></span>
      </div>
    </div>
  </div>
  <hr />
</div>
